<template>
  <div class="modal-card confirm-modal">
    <div class="modal-header">
      <p class="modal-header-text">{{ $t('exchange.on_process') }}</p>
      <div
        class="modal-header-close-btn"
        @click="$parent.close()"
      >
        <img src="/static/svg/close-symbol.svg">
      </div>
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <img src="/static/gif/exchange-process-animate.gif">
        <div class="token-info">
          {{ $t('exchange.tx_is_pending_text') }}
        </div>
        <div class="address-info">
          <p>{{ $t('exchange.you_can_view_tx') }}</p>
          <a
            :href="`${etherScanUrl}/tx/${hash}`"
            target="_blank"
            class="address-info-tx"
          >
            {{ shortHash }}
            <img src="/static/svg/open-new-tab-blue.svg">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnProcessModal',
  props: {
    hash: {
      type: String,
      default: ''
    },
    etherScanUrl: {
      type: String,
      default: 'https://etherscan.io'
    }
  },
  computed: {
    shortHash () {
      const first = this.hash.substr(0, 12)
      const last = this.hash.substr(this.hash.length - 12, this.hash.length)
      return `${first}...${last}`
    }
  }
}
</script>
<style scoped>
  .confirm-modal {
    float: left;
    width: 530px;
    height: 530px;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .modal-header {
    float: left;
    width: 100%;
    height: 62px;
    background-color: #0559af;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-header-text {
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #ffffff;
  }
  .modal-header-close-btn {
    position: absolute;
    top: 15px;
    right: 19px;
  }
  .modal-header-close-btn {
    cursor: pointer;
  }
  .modal-body {
  float: left;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  }
  .modal-content {
    width: 100%;
    float: left;
    padding: 40px 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .token-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 35px;
    text-align: center;
  }
  .address-info{
    float: left;
    padding: 0px 15px;
    width: 100%;
    text-align: center;
    margin: 30px 0;
  }
  .address-info-tx {
    color: #0564c4;
    margin-top: 5px;
    overflow: hidden;
  }
  @media only screen and (max-width: 768px) {
    .confirm-modal {
      width: 100%;
      /* height: 530px; */
    }
    .modal-content {
      padding: 40px 10px;
      margin: 10px 0;

    }
    .is-mobile-margin {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OnProcessModal.vue